import React, { useEffect } from 'react';
import { Skeleton, Typography } from 'fronton-react';
import { TData } from 'entries/common/widgets/saved-project-configurations-list/context';
import { useSearchSavedConfigurations } from '../common/hooks/use-search-configurations';
import { SavedProjectsCarousel } from './components/saved-projects-carousel';
import { Container } from './styles';
import { CALCULATORS_LAMINATE_CLOSE_CONFIGURATION_EVENT } from './constants';

export const SavedProjectConfigurationsListPage = ({ data }: { data: TData }) => {
  const { isCarouselShown, api, authorizedCustomerId, unauthorizedCustomerId } = data;
  const {
    configurationItems,
    isResponseEmpty,
    isLoading,
    isError,
    isLoaded,
    getConfigurations,
  } = useSearchSavedConfigurations({
    isRequestAvailable: data.isCarouselShown ?? false,
    apiMethods: api,
    authorizedCustomerId,
    unauthorizedCustomerId,
  });

  useEffect(() => {
    const cb = () => {
      getConfigurations();
    };

    document.body.addEventListener(CALCULATORS_LAMINATE_CLOSE_CONFIGURATION_EVENT, cb);

    return () => {
      document.body.removeEventListener(CALCULATORS_LAMINATE_CLOSE_CONFIGURATION_EVENT, cb);
    };
  }, [getConfigurations]);

  if (!isCarouselShown || isResponseEmpty || isError) {
    return null;
  }

  return (
    <Container>
      <Skeleton variant="control" showLoading={isLoading || !isLoaded} width="300px" height="24px">
        <Typography size="overline" variant="m">
          Сохранённые расчёты
        </Typography>
      </Skeleton>
      <Skeleton variant="control" showLoading={isLoading || !isLoaded} width="100%" height="164px">
        <SavedProjectsCarousel configurations={configurationItems} />
      </Skeleton>
    </Container>
  );
};
